import { cva } from 'class-variance-authority';

var clazz = cva("", {
    variants: {},
    defaultVariants: {}
});

export { clazz };
